import React from 'react';
import { Outlet } from 'react-router-dom';

const ConsentScene = () => {
  return <Outlet />;
};

export default ConsentScene;
